<div class="grid-builder">
  <div
    class="grid-builder-header"
    [class.sticky-header]="stickyHeader"
    [style.grid-template-columns]="headerColumnConfig"
  >
    <div
      *ngIf="defaultRows?.length || gridTitle"
      [ngClass]="gridCornerClass"
      [class.sticky-left]="rowHeaderSticky"
      class="corner cell-border"
    >
      {{ gridTitle }}
    </div>
    <div
      class="grid-builder-header-cell cell-border"
      [ngClass]="column.columnHeaderClass"
      *ngFor="let column of columns; let colIndex = colIndex"
    >
      <ng-container
        *ngTemplateOutlet="
          columnHeaderTemplate || valueDefaultTpl;
          context: {
            value: column.columnName || '-',
            column: column,
            colIndex: colIndex,
            headerClass: column.columnHeaderClass
          }
        "
      ></ng-container>
    </div>
  </div>
  <div
    class="grid-builder-row"
    *ngFor="let row of defaultRows; let rowIndex = index"
    [style.grid-template-columns]="headerColumnConfig"
  >
    <div
      class="grid-builder-row-titles"
      [class.sticky-left]="rowHeaderSticky"
      *ngIf="defaultRows?.length || gridTitle"
      [style.grid-row]="'1 / ' + ((row.childRows?.length || 0) + 1)"
    >
      <ng-container>
        <ng-container
          *ngTemplateOutlet="
            rowHeadTpl;
            context: { row: row, rowIndex: rowIndex }
          "
        ></ng-container>
      </ng-container>
    </div>
    <div
      class="grid-builder-row auto-columns"
      [style.grid-column]="'2 / ' + (columns.length + 2)"
      *ngFor="
        let row of row.childRows?.length ? row.childRows : [row];
        let rowIndex = index
      "
    >
      <div
        class="grid-builder-row-cell cell-border"
        *ngFor="let column of columns; let colIndex = index"
      >
        <ng-container
          *ngTemplateOutlet="
            cellTemplate || valueDefaultTpl;
            context: {
              value: (row.data || {})[column.bindProperty] || '-',
              row: row,
              column: column,
              rowIndex: rowIndex,
              colIndex: colIndex,
              cellClass: getCellClass(column, row)
            }
          "
        ></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #rowHeadTpl let-row="row" let-subRow="isSubRow">
  <div
    class="grid-builder-row-title"
    [ngClass]="row.rowTitleClass"
    [style.grid-template-columns]="
      row.childRows?.length
        ? '1fr ' + subHeaderColumnWidth
        : subRow
        ? rowSubHeaderWidth
        : rowHeaderWidth
    "
  >
    <div class="title cell-border">
      <ng-container
        *ngTemplateOutlet="
          (subRow ? subRowHeaderTemplate : rowHeaderTemplate) ||
            valueDefaultTpl;
          context: { value: row.rowTitle, row: row }
        "
      ></ng-container>
    </div>
    <div class="sub-titles" *ngIf="row.childRows?.length">
      <ng-container *ngFor="let childRow of row.childRows">
        <ng-container
          *ngTemplateOutlet="
            rowHeadTpl;
            context: { row: childRow, isSubRow: true }
          "
        ></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #valueDefaultTpl let-value="value" let-cellClass="cellClass">
  <div
    class="h-100 d-flex align-items-center justify-content-center default-value"
    [ngClass]="cellClass"
  >
    {{ value }}
  </div>
</ng-template>
